const Redeem = {
  path: "",
  name: "",
  redirect: "/transaction-code",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/transaction-code",
      redirect: "/transaction-code",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Transaction Code",
      meta: {
        requiresAuth: true,
        activeUrl: "/transaction-code",
        parent: "/transaction-code",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/transactionCode"),
          meta: {
            requiresAuth: true,
            activeUrl: "/transaction-code",
            parent: "/transaction-code",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Transaction Code Detail",
          component: () => import("@/views/pages/transactionCode/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/transaction-code",
            parent: "/transaction-code",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Redeem;
